export const academyRecommendedContentKeys = {
  root: ['academyRecommendedContent'],
  recommendedContents: (academyId: string, filters?: any) =>
    filters
      ? [...academyRecommendedContentKeys.root, academyId, 'recommendedContents', filters]
      : [...academyRecommendedContentKeys.root, academyId, 'recommendedContents'],
};

export const academyRecommendedContentKeysForLearner = {
  root: ['academyRecommendedContentForLearner'],
  recommendedContents: (academyId: string) => [...academyRecommendedContentKeys.root, academyId, 'recommendedContents'],
  externalUserInfo: (academyId: string) => [...academyRecommendedContentKeys.root, academyId, 'externalUserInfo'],
};
